import React, { Suspense, lazy ,useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { HelmetProvider } from 'react-helmet-async';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './components/common/ScrollToTop';

import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ProtectedRoute from './components/common/ProtectedRoute';
import { PageLoader } from './components/ui/Skeletons';
import ErrorBoundary from './components/common/ErrorBoundary';

// Lazy-loaded pages for code splitting
const Home          = lazy(() => import('./pages/Home'));
const Products      = lazy(() => import('./pages/Products'));
const ProductDetail = lazy(() => import('./pages/ProductDetail'));
const Cart          = lazy(() => import('./pages/Cart'));
const Checkout      = lazy(() => import('./pages/Checkout'));
const Login         = lazy(() => import('./pages/Login'));
const Register      = lazy(() => import('./pages/Register'));
const OrderSuccess  = lazy(() => import('./pages/OrderSuccess'));
const MyOrders      = lazy(() => import('./pages/MyOrders'));
const Wishlist      = lazy(() => import('./pages/Wishlist'));
const Profile       = lazy(() => import('./pages/Profile'));
const Contact       = lazy(() => import('./pages/Contact'));

// 🚀 ── NEW COMPLIANCE LEGAL PAGES IMPORTS ──
const ShippingPolicy = lazy(() => import('./pages/ShippingPolicy'));
const RefundPolicy   = lazy(() => import('./pages/RefundPolicy'));
const PrivacyPolicy  = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));

const NotFound      = lazy(() => import('./pages/NotFound'));

function PixelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]); // Har baar path/page badalne par ye Meta ko batayega

  return null;
}

export default function App() {
  return (
    <HelmetProvider>
 <HashRouter>
  <ScrollToTop />
  <PixelTracker /> 
  <AuthProvider>
          <CartProvider>
            <WishlistProvider>
              <ErrorBoundary>
                <div className="min-h-screen flex flex-col bg-green-950">
                  <Navbar />
                  <main className="flex-1">
                    <Suspense fallback={<PageLoader />}>
                      <Routes>
                        <Route path="/"                element={<Home />} />
                        <Route path="/products"        element={<Products />} />
                        <Route path="/products/:id"    element={<ProductDetail />} />
                        <Route path="/login"           element={<Login />} />
                        <Route path="/register"        element={<Register />} />
                        <Route path="/cart"            element={<Cart />} />
                        <Route path="/wishlist"        element={<Wishlist />} />
                        <Route path="/checkout"        element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
                        <Route path="/order-success/:id" element={<ProtectedRoute><OrderSuccess /></ProtectedRoute>} />
                        <Route path="/my-orders"       element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
                        <Route path="/profile"         element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                        <Route path="/contact"         element={<Contact />} />
                        
                        {/* 🚀 ── RAZORPAY COMPLIANCE LIVE ROUTES ── */}
                        <Route path="/shipping-policy" element={<ShippingPolicy />} />
                        <Route path="/refund-policy"   element={<RefundPolicy />} />
                        <Route path="/privacy-policy"  element={<PrivacyPolicy />} />
                        <Route path="/terms"           element={<TermsConditions />} />
                        
                        <Route path="*"                element={<NotFound />} />
                      </Routes>
                    </Suspense>
                  </main>
                  <Footer />
                </div>
              </ErrorBoundary>
              <ToastContainer
                position="bottom-right"
                autoClose={3000}
                theme="dark"
                closeButton={false}
              />
            </WishlistProvider>
          </CartProvider>
        </AuthProvider>
      </HashRouter>
    </HelmetProvider>
  );
}